<template>
  <div class="item-cart-container normal-button" @click="onClick">
    <span class="amount amount-container">${{giftItem.egift_amount}} {{giftItem.type}}</span>
    <vue-barcode
      :value="item.redeem_code"
      class="barcode"
      font="SFProText-Medium, -apple-system"
      fontSize="16px"
      fontOptions="500"
      textMargin="10px"
      background="transparent"
    />
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
export default {
  name: "ItemCard",
  components: {
    VueBarcode
  },
  props: {
    item: {
      type: Object,
      isRequired: true
    }
  },
  computed: {
    giftItem() {
      return this.item.item;
    }
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    }
  }
};
</script>
<style lang="scss" scoped>
.item-cart-container {
  display: flex;
  flex-direction: column;
  margin: 0 10px 20px 10px;
  padding: 20px;
  background-color: rgba($color: #ffffff, $alpha: 0.8);
  border-radius: 5px;
  box-shadow: 0 10px 20px rgba($color: #000000, $alpha: 0.1);
  .amount-container {
    align-self: center;
  }
  .row-item {
    display: flex;
    align-items: center;
    .logo-price-tag {
      width: 25px;
      height: auto;
    }
  }
  .gift-description {
    font-size: 16px;
  }
  .barcode {
    align-self: center;
    margin-top: 25px;
    font-weight: 500 !important;
  }
}
</style>